import { Modal } from "antd";
import { useTranslation } from "react-i18next";

const UnAuthModal = ({ open, onLogin, openLoginModal }) => {
    const { t } = useTranslation();

    return (
        <Modal
            title={t("sessionExpired")}
            open={open}
            centered
            closable={false}
            maskClosable={false}
            footer={null}
        >
            <p>{t("sessionExpiredMessage")}</p>

            <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                    onLogin();
                    openLoginModal();
                }}
            >
                {t("loginAgain")}
            </button>
        </Modal>
    );
};

export default UnAuthModal;